import { render, staticRenderFns } from "./Managers.vue?vue&type=template&id=7937c5dc&scoped=true"
import script from "./Managers.vue?vue&type=script&lang=js"
export * from "./Managers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7937c5dc",
  null
  
)

export default component.exports